"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFrameMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const react_1 = require("react");
const use_determine_ui_mode_1 = require("../../../hooks/use_determine_ui_mode");
const loading_screen_1 = require("./loading_screen");
const user_audio_status_1 = require("./user_audio_status");
const camera_inactive_screen_1 = require("./camera_inactive_screen");
function VideoFrameMobile({ videoController }) {
    var _a;
    const theme = (0, ui_react_1.useTheme)();
    const canvasContainer = (0, react_1.useRef)(null);
    // feed what we know about the current display layout into useDetermineUIMode, and it'll tell us what display mode to use.
    const determinedUIProperties = (0, use_determine_ui_mode_1.useDetermineUIMode)({
        videoController,
        canvasContainer,
    });
    const [freezeFrameImgSrc, setFreezeFrameImgSrc] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        const inPip = determinedUIProperties.switches.inPip;
        const enabledSubscription = videoController.enabled.subscribe(enabled => {
            if (inPip && !enabled && canvasContainer && canvasContainer.current) {
                const remoteCanvas = canvasContainer.current.querySelector('canvas');
                if (remoteCanvas) {
                    // take a snapshot of the remote video canvas
                    const canvasDataURL = remoteCanvas.toDataURL('image/jpeg', 0.4);
                    setFreezeFrameImgSrc(canvasDataURL);
                }
            }
            else {
                setFreezeFrameImgSrc(undefined);
            }
        });
        return () => {
            enabledSubscription.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoController]);
    /*
    Because this same component gets rendered for both local and remote versions of the component
    determinedUIProperties is divided into local and remote sections, so determinedVideoFrameUI
    holds only ONE of those--local for local video sessions and remote for remote videos, making
    it easy to read the settings from the same object regardless of which version it's rendering
    */
    return ((0, jsx_runtime_1.jsx)(VideoContainerWrapper, Object.assign({ theme: theme }, { children: (0, jsx_runtime_1.jsxs)(VideoContainer, Object.assign({ ref: canvasContainer, theme: theme, "data-testid": 'video-frame-test-id-' + determinedUIProperties.videoOwner, determinedVideoFrameUI: determinedUIProperties, className: `${determinedUIProperties.switches.inPip ? 'inPip' : 'notInPip'} ${determinedUIProperties.switches.inPip &&
                !((_a = determinedUIProperties.raw) === null || _a === void 0 ? void 0 : _a.remoteVideoEnabled) &&
                determinedUIProperties.videoOwner === 'remote'
                ? 'hiddenPip'
                : ''}` }, { children: [(0, jsx_runtime_1.jsx)(FreezeFrameImg, { src: freezeFrameImgSrc, alt: "video tranistion freeze frame", style: {
                        visibility: freezeFrameImgSrc !== undefined ? 'visible' : 'hidden',
                    } }), (0, jsx_runtime_1.jsx)(camera_inactive_screen_1.CameraInactiveScreen, { videoController: videoController, determinedUIProperties: determinedUIProperties, 
                    /* This will probably need to be updated when the fix for the icon-vs-text bit is resolved in CameraInactiveScreen */
                    mobileDisplay: true }), (0, jsx_runtime_1.jsx)(loading_screen_1.LoadingScreen, { videoController: videoController }), (0, jsx_runtime_1.jsx)(user_audio_status_1.UserAudioStatus, { videoController: videoController, isPipDisplay: true, cssClassName: "userAudioStatusWrapper" })] })) })));
}
exports.VideoFrameMobile = VideoFrameMobile;
const VideoContainer = ui_react_1.styled.div(({ determinedVideoFrameUI }) => (Object.assign({ '--base-height': '150px', borderRadius: determinedVideoFrameUI.switches.inPip ? '10px' : '0px', position: 'absolute', overflow: 'hidden', top: 0, left: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', transition: 'inherit', zIndex: determinedVideoFrameUI.switches.inPip ? 3 : 2 }, determinedVideoFrameUI.styles)));
const VideoContainerWrapper = ui_react_1.styled.div `
    border: none;
    background: ${props => props.theme.colors.black};
    position: absolute;
    width: 100%;
    height: 100%;
    ${ui_react_1.SafariLandscapeFullHeightHack}

    .notInPip {
        transition: zIndex 0s, height 0.35s ease-in-out, width 0.35s ease-in-out,
            left 0.35s ease-in-out, top 0.35s ease-in-out;
        border-radius: 0;
    }

    // if we are in PiP mode, increase the z-index, and add some padding
    .inPip {
        transition: zIndex 0s, height 0.35s ease-in-out, width 0.35s ease-in-out,
            left 0.35s ease-in-out, top 0.35s ease-in-out, opacity 0.35s ease-in-out;
        z-index: 3;
        margin-left: 3vw;
        margin-top: 3vw;

        .userAudioStatusWrapper {
            opacity: 1;
            // take out this block and the below opacity: 0; if you're switching to an .animation() driven solution
            transition: opacity 0.25s ease-in-out 0.5s, border-radius 0.5s ease-in-out;
        }
    }

    .hiddenPip {
        opacity: 0;
    }

    .userAudioStatusWrapper {
        opacity: 0;
        transition: opacity 0s;
    }
`;
const FreezeFrameImg = ui_react_1.styled.img `
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    object-fit: contain;
    background: inherit;
    border-radius: '20px';
`;
//# sourceMappingURL=video_frame_mobile.js.map